import request from '@/utils/request'

/**
 * 获取库位列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export const getStorageLocations = (params) => {
  return request({
    url: '/api/storage-locations',
    method: 'get',
    params
  })
}

/**
 * 创建库位
 * @param {Object} data - 库位数据
 * @returns {Promise}
 */
export const createStorageLocation = (data) => {
  return request({
    url: '/api/storage-locations',
    method: 'post',
    data
  })
}

/**
 * 获取库位详情
 * @param {number} locationId - 库位ID
 * @returns {Promise}
 */
export const getStorageLocation = (locationId) => {
  return request({
    url: `/api/storage-locations/${locationId}`,
    method: 'get'
  })
}

/**
 * 更新库位
 * @param {number} locationId - 库位ID
 * @param {Object} data - 更新数据
 * @returns {Promise}
 */
export const updateStorageLocation = (locationId, data) => {
  return request({
    url: `/api/storage-locations/${locationId}`,
    method: 'put',
    data
  })
}

/**
 * 删除库位
 * @param {number} locationId - 库位ID
 * @returns {Promise}
 */
export const deleteStorageLocation = (locationId) => {
  return request({
    url: `/api/storage-locations/${locationId}`,
    method: 'delete'
  })
}

/**
 * 永久删除库位（无子库位、无库存及关联业务记录时可删，删除后编码可重新占用）
 * @param {number} locationId - 库位ID
 * @returns {Promise}
 */
export const forceDeleteStorageLocation = (locationId) => {
  return request({
    url: `/api/storage-locations/${locationId}/force-delete`,
    method: 'delete'
  })
}

/**
 * 切换库位状态
 * @param {number} locationId - 库位ID
 * @param {Object} data - 状态数据
 * @returns {Promise}
 */
export const toggleStorageLocationStatus = (locationId, data) => {
  return request({
    url: `/api/storage-locations/${locationId}/status`,
    method: 'patch',
    data
  })
}

/**
 * 获取库位树形结构
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export const getStorageLocationTree = (params) => {
  return request({
    url: '/api/storage-locations/tree',
    method: 'get',
    params
  })
}

/**
 * 批量创建库位
 * @param {Object} data - 批量创建数据
 * @param {number} data.parent_location_id - 父级库位ID（货架）
 * @param {string} data.prefix - 库位前缀（如M）
 * @param {number} data.start_number - 起始编号（如1）
 * @param {number} data.end_number - 结束编号（如55）
 * @param {string} data.location_type - 库位类型，默认为bin（库位）
 * @returns {Promise}
 */
export const batchCreateStorageLocations = (data) => {
  return request({
    url: '/api/storage-locations/batch',
    method: 'post',
    data
  })
}